import { render, staticRenderFns } from "./WorldViewsPage.vue?vue&type=template&id=10c93e82&scoped=true"
import script from "./WorldViewsPage.vue?vue&type=script&lang=ts"
export * from "./WorldViewsPage.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewsPage.vue?vue&type=style&index=0&id=10c93e82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c93e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c93e82')) {
      api.createRecord('10c93e82', component.options)
    } else {
      api.reload('10c93e82', component.options)
    }
    module.hot.accept("./WorldViewsPage.vue?vue&type=template&id=10c93e82&scoped=true", function () {
      api.rerender('10c93e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/WorldViewsPage.vue"
export default component.exports